// @flow
import {PureComponent} from 'react';
import {connect} from 'react-redux';

import {evaluateExperimentAndLog} from '@homeaway/abacus-client-utils';
import {
    HA_TRAVSEG_SERP_AMENITIES,
    HA_TRAVSEG_SERP_FILTER
} from '../../../abacus/experiments';

// track which experiments are part of react-segmentation
const EXPERIMENTS = {
    [HA_TRAVSEG_SERP_AMENITIES]: true,
    [HA_TRAVSEG_SERP_FILTER]: true
};

type ExperimentName = $Keys<typeof EXPERIMENTS>;

type StateProps = {
    evaluationData?: Object
};
type Props = {
    children: ({evaluationData: {value: number}}) => React.Element<*> | void,
    experimentName: ExperimentName
} & StateProps;

const experimentLogs = {
    HA_TRAVSEG_SERP_AMENITIES: false,
    HA_TRAVSEG_SERP_FILTER: false
};

export class Experiment extends PureComponent<Props> {
    componentDidMount() {
        const {experimentName} = this.props;
        if (!experimentLogs[experimentName]) {
            experimentLogs[experimentName] = true;
            evaluateExperimentAndLog(experimentName);
        }
    }

    render() {
        const {children, evaluationData} = this.props;
        return children({
            evaluationData: evaluationData || {value: 0}
        });
    }
}

const mapStateToProps = ({abacus}, {experimentName}) => ({
    evaluationData: abacus[experimentName]
});

export default connect(mapStateToProps)(Experiment);
